import { usePage } from '@inertiajs/vue3'

export default {
    /**
     *
     * @param value
     * @param digits
     * @param marketRegionId
     * @returns {string}
     */
    priceFormat (value, digits = 2, marketRegionId = null) {
        const numberFormat = new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: digits
        }).format(value)

        return `${this.getCurrencyCode(marketRegionId)} ${numberFormat}`
    },

    /**
     *
     * @param value
     * @param decimals
     * @returns {string}
     */
    pricePercentage (value, decimals = 3) {
        return new Intl.NumberFormat('default', { style: 'percent', minimumFractionDigits: decimals }).format(value / 100)
    },

    /**
     *
     * @param value
     * @param digits
     * @param marketRegionId
     * @returns {string}
     */
    priceFormatForDisplay (value, digits = 2, marketRegionId = null) {
        const numberFormat = new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: digits
        })
            .format(this.internationalToNormalFormat(value))

        return `${this.getCurrencyCode(marketRegionId)} ${numberFormat}`
    },

    /**
     *
     * @param value
     * @returns {string}
     */
    percentageFormatForDisplay (value) {
        return new Intl.NumberFormat('de-DE', {
            style: 'percent',
            minimumFractionDigits: 3
        })
            .format(this.internationalToNormalFormat(value) / 100)
    },

    /**
     *
     * @param value
     * @returns {string}
     */
    numberFormatForInput (value) {
        return new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: 3
        })
            .format(this.internationalToNormalFormat(value))
    },

    /**
     *
     * @param value
     * @returns {number}
     */
    internationalToNormalFormat (value) {
        // If the value is not in the German format do not do any cleansing
        if (String(value).match(/^-?(\d{1,3}\.)*\d{1,3},\d{3}$/) === null) {
            return value
        }

        if (value === null) {
            return 0
        }

        // trying to convert it back to a number, recognized as 'float' by computer systems
        value = value.replace('.', '') // We forcefully only expect "german formatted input" here, removing that grouping character
        value = value.replace("'", '') // We only expect "german formatted input" here
        value = value.replace('`', '') // We only expect "german formatted input" here
        value = value.replace('´', '') // We only expect "german formatted input" here
        value = value.replace(' ', '') // removing not-allowed character caused by "copy&paste"
        value = value.replace('%', '') // removing not-allowed character caused by "copy&paste"
        value = value.replace('€', '') // removing not-allowed character caused by "copy&paste"
        value = value.replace(',', '.') // We only expect "german formatted" input here, so a comma is a decimal separator

        return value
    },

    /**
     *
     * @param marketRegionId
     * @returns {string}
     */
    getCurrencyCode (marketRegionId) {
        return usePage().props.marketRegions?.[marketRegionId]?.currency_code ?? 'N/A'
    },

    /**
     * Formats an amount in an explicitly given currency, for figures whose currency is fixed
     * by the domain rather than by the tenant or the customer's market region.
     *
     * @param value
     * @param currencyCode
     * @param digits
     * @returns {string}
     */
    priceFormatForDisplayInCurrency (value, currencyCode, digits = 2) {
        const numberFormat = new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: digits
        })
            .format(this.internationalToNormalFormat(value))

        return `${currencyCode} ${numberFormat}`
    }
}
